module.exports = __webpack_public_path__ + "img/zhihui1.df8dfdc4.png";